import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "../Actions/commonFunction";
import Scoreintermodal from "../Modal/Scoreinter";

function Vacscorecard() {
  const {
    answer: { answer, totalscore },
    question,
    questiondetails
  } = useSelector((state) => state?.user);
  console.log("🚀 ~ Vacscorecard ~ answer:", answer,questiondetails);
  const [toatalScore, setTotalScore] = useState(totalscore);
  const [data, setData] = useState([]);
  const [scoremodal, setScoremodal] = useState(false);
  console.log("scoremodal:", scoremodal)
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const convertTableformat = () => {
    let retData = [],
      totalscore = 0;
    let keys = Object.keys(question?.question);
    for (let i = 0; i < keys?.length; i++) {
      let questions = question?.question[keys[i]];
      console.log("🚀 ~ convertTableformat ~ questions:", questions);
      for (let j = 0; j < questions?.length; j++) {
        let category = j == 0 ? keys[i] : "";
        retData.push({
          category,
          question: questions[j]?.question,
          answer: answer?.[keys[i]]?.[j],
          score: answer?.[keys[i]]?.[j] == "yes" ? 1 : 0,
        });
      }
    }
    setData(retData);
  };

  useEffect(() => {
    if (!isEmpty(question?.question) && !isEmpty(answer)) {
      convertTableformat();
    }
  }, [question, answer]);

  return (
    <>
    {scoremodal && <Scoreintermodal totalscore={toatalScore} onDismiss={()=>setScoremodal(false)}/>}
    <div>
      <div>
        <Header />
        <div className="inner_page position-relative ">
          <img src={Images.elogo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-5 pb-5">
            <div className="vac_border position-relative rounded-3 py-5 px-3 px-sm-4">
              <img src={Images.a1logo} className="a1logo" alt="round" />
              <img src={Images.a2logo} className="a2logo" alt="elogo" />
              <img src={Images.a2logo} className="a3logo" alt="elogo" />
              <Row>
                <Col xl={9} xxl={10} className="mx-auto position-relative">
                  <img
                    src={Images.smallround}
                    className="bot_round"
                    alt="round"
                  />
                  <img
                    src={Images.smallround}
                    className="top_round"
                    alt="round"
                  />
                  <div className="vac_border academy pt-4">
                    <h4 className="text-center pb-3 px-2 fw-600">
                      Here is the EdaFace Academy SOC Scorecard for EDA coin
                    </h4>
                    <Table bordered hover responsive className="mb-0">
                      <thead>
                        <tr className="score_head">
                          <th rowSpan={2}>Item</th>
                          <th rowSpan={2}>Scorecard Investigative Question</th>
                          <th colSpan={2}>Response</th>
                        </tr>
                        <tr>
                          <th>
                            <p className="mb-0 hno">Answer</p>
                            <p className="mb-0 s_txt">yes/no</p>
                          </th>
                          <th>
                            <p className="mb-0 hno">Score</p>
                            <p className="mb-0 s_txt">yes=1 no=0</p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((row, index) => (
                          <tr key={index}>
                            <td className="text-center fw-600">
                              {row.category || ""}
                            </td>
                            <td>{row.question}</td>
                            <td className="text-center">{row.answer}</td>
                            <td className="text-center">{row.score}</td>
                          </tr>
                        ))}
                        <tr>
                          <td
                            className="text-center fw-600 tblefinal_head"
                            colSpan={2}
                          >
                            Total Score
                          </td>
                          <td></td>
                          <td className="text-center">{toatalScore}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>


                  <button className="themebtn themehoverbtn rounded-1 py-3 my-3 fw-600" onClick={()=>setScoremodal(true)}>See Score Interpretation</button> 

                  {/* <div className="vac_border interpretation pt-4">
                    <h4 className="text-center pb-3">
                      SOC Interpretation of Score
                    </h4>
                    <Table bordered hover responsive className="mb-1">
                      <thead>
                        <tr>
                          <th className="hno">Investment Interpretation</th>
                          <th className="hno">Total Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log(questiondetails?.interpretation,"questiondetails?.interpretation")}
                        
                        {
                          questiondetails?.interpretation?.length > 0 && 
                          questiondetails?.interpretation?.map((val)=>(
                            <tr>
                            <td>{Object.keys(val)[0]}</td>
                            <td>{Object.values(val)[0]}</td>
                          </tr>
                          ))
                        }
                      
                      </tbody>
                    </Table>
                  </div> */}
                  {console.log('totalscore-->',totalscore,question.minscore)}
                  {totalscore >= Number(question.minscore) && (
                    <div className="text-end me-4 mt-3">
                      <Link to="/vac-system">
                        <button
                          type="button"
                          className="themebtn themehoverbtn rounded-1 mt-1 py-2 px-3 fw-600"
                        >
                          Go to Listing Page
                        </button>
                      </Link>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </div>
    </>
  );
}

export default Vacscorecard;
